import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faCoffee, faWifi, faConciergeBell, faCar, faLeaf } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion'; // Importa motion da framer-motion
import { useInView } from 'react-intersection-observer'; // Importa useInView per rilevare l'entrata nella vista
import { useLanguage } from '../context/LanguageContext'; // Importa useLanguage dal contesto della lingua

function Services() {
    const { isEnLang } = useLanguage(); // Usa il contesto della lingua per determinare la lingua corrente

    const { ref: ref1, inView: inView1 } = useInView(); // Hook per rilevare se il componente è nella vista
    const { ref: ref2, inView: inView2 } = useInView();
    const { ref: ref3, inView: inView3 } = useInView();
    const { ref: ref4, inView: inView4 } = useInView();
    const { ref: ref5, inView: inView5 } = useInView();
    const { ref: ref6, inView: inView6 } = useInView();

    const variants = {
        hidden: { opacity: 0, y: 100 }, // Animazione di partenza (nascosto fuori dallo schermo in basso)
        visible: { opacity: 1, y: 0 }, // Animazione di entrata (visibile con slide-up)
    };

    // Testi in entrambe le lingue
    const text = {
        en: {
            title: "The Best for Your Relaxation and Well-being",
            services: [
                {
                    icon: faBed,
                    title: "Modern Rooms",
                    description: "Modern and cozy rooms with all the necessary comforts for a relaxing vacation."
                },
                {
                    icon: faCoffee,
                    title: "Included Breakfast",
                    description: "Free and delicious breakfast to start your day off right."
                },
                {
                    icon: faWifi,
                    title: "Free Wi-Fi",
                    description: "Free Wi-Fi available throughout the property."
                },
                {
                    icon: faConciergeBell,
                    title: "Tourist Assistance",
                    description: "Assistance service for tourist information and booking local activities in Anzio and Nettuno."
                },
                {
                    icon: faCar,
                    title: "Reserved Parking",
                    description: "Reserved parking and electric charging for a convenient and efficient stay."
                },
                {
                    icon: faLeaf,
                    title: "Eco-friendly House",
                    description: "Single-family house completely green with sustainable technologies."
                }
            ]
        },
        it: {
            title: "Il Meglio per il Tuo Relax e Benessere",
            services: [
                {
                    icon: faBed,
                    title: "Camere Moderne",
                    description: "Camere moderne e accoglienti con tutti i comfort necessari per una vacanza rilassante."
                },
                {
                    icon: faCoffee,
                    title: "Colazione Inclusa",
                    description: "Colazione gratuita e deliziosa per iniziare al meglio la tua giornata."
                },
                {
                    icon: faWifi,
                    title: "Wi-Fi Gratuito",
                    description: "Connessione Wi-Fi gratuita disponibile in tutta la struttura."
                },
                {
                    icon: faConciergeBell,
                    title: "Assistenza Turistica",
                    description: "Servizio di assistenza per informazioni turistiche e prenotazioni di attività locali ad Anzio e Nettuno."
                },
                {
                    icon: faCar,
                    title: "Posto Auto Riservato",
                    description: "Posto auto riservato e ricarica elettrica per un soggiorno comodo ed efficace."
                },
                {
                    icon: faLeaf,
                    title: "Casa Ecologica",
                    description: "Casa unifamiliare totalmente green con tecnologie sostenibili."
                }
            ]
        }
    };

    // Scegli i testi in base alla lingua corrente
    const { title, services } = isEnLang ? text.en : text.it;

    return (
        <section className="services" id="services">
            <div className="title">
                <h2>{title}</h2>
            </div>
            <div className="services-box">
                <ul>
                    {services.map((service, index) => (
                        <motion.li
                            key={index}
                            ref={[ref1, ref2, ref3, ref4, ref5, ref6][index]} // Assegna il riferimento corretto
                            initial="hidden" // Stato iniziale (nascosto)
                            animate={[inView1, inView2, inView3, inView4, inView5, inView6][index] ? "visible" : "hidden"} // Animazione attivata quando il componente è nella vista
                            variants={variants} // Variante per l'animazione
                            transition={{ duration: 0.5 }} // Durata dell'animazione
                        >
                            <FontAwesomeIcon icon={service.icon} />
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                        </motion.li>
                    ))}
                </ul>
            </div>
        </section>
    )
}

export default Services;
